import React from 'react';

const SvgTl = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TL_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TL_svg__b" fill="#fff">
        <use xlinkHref="#TL_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TL_svg__a" />
      <path fill="#FF323E" mask="url(#TL_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#FFCC51" mask="url(#TL_svg__b)" d="M0 0l17.333 10L0 20z" />
      <path fill="#262626" mask="url(#TL_svg__b)" d="M0 0l12 10L0 20z" />
      <path
        fill="#FFF"
        mask="url(#TL_svg__b)"
        transform="rotate(-30 5.227 9.583)"
        d="M5.227 11.016l-1.735 1.237.64-2.032L2.42 8.953l2.13-.02.677-2.02.677 2.02 2.131.02-1.713 1.268.64 2.032z"
      />
    </g>
  </svg>
);

export default SvgTl;
